import * as React from "react";
import Button, { ButtonProps } from "@ebsco-ui/button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/pro-light-svg-icons";
import cn from "classnames";

import "@ebsco-ui/button/button.scss";
import "./close-button.scss";

export interface CloseButtonProps extends ButtonProps {
  /** Set autoFocus property on the Button child component */
  autoFocus?: boolean;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  title: string;
}

const CloseButton: React.FC<CloseButtonProps> = ({
  title,
  onClick,
  autoFocus,
  className,
  ...rest
}) => (
  <Button
    className={cn("close-button", className)}
    styleType="flat-icon"
    onClick={onClick}
    title={title}
    data-auto="close-button"
    autoFocus={autoFocus}
    {...rest}
  >
    <FontAwesomeIcon icon={faTimes} />
  </Button>
);

export default CloseButton;
